import { api } from '@/services/api'
import type { WorkflowSummary } from '@/types/workflowSummary'

export async function getWorkflowSummaries(): Promise<WorkflowSummary[]> {
  return api.get<WorkflowSummary[]>('/v1/workflows/summary')
}
